import FormSystemError from '../../../utils/form-error-constants'
import Tooltip from '../tooltip'

class Checkout {
    constructor() {
        this.formErrorConstants = new FormSystemError('#paymentMethod, #shippingMethod, #userInfoForm');
        this.formErrorConstants.init();
        const MobileDetect = require('mobile-detect');
        this.mobileDetect = new MobileDetect(window.navigator.userAgent);
    }

    init() {
        let formSystemError = new FormSystemError();
        formSystemError.init();

        $(document).on('change', '#nbr, #zip', (event) => {
            let $accountForm = $(event.target).closest("form");
            let zipCode = $accountForm.find('#zip').val();
            let number = $accountForm.find('#nbr').val();
            let $street = $accountForm.find('#street');
            let $city = $accountForm.find('#city');

            if (this.chosenCountry() === 'Nederland') {
                this.loadAddress(
                    zipCode,
                    number,
                    $street,
                    $city,
                    $('#inv_loader')
                );
            }
        });

        $('.deliverPoints').on('click', 'a.findLocations', {thisClass: this}, this.getLocations);
        $('.searchInputColumn>input[name=zipCode]').on('keypress', function(event) {
          let keycode = event.keyCode || event.which;
          if(keycode == '13') {
            event.preventDefault();
            $('.deliverPoints a.findLocations').click();
            return true;
          }
        });

        this.createNewUser();
        this.initCoupon();
        this.shippings();
        this.initPayment();
        this.createNewSameEmail();
    }

    chosenCountry() {
        return $('#fc_land').val() || $('#country').val();
    }

    /**
     *
     * @param zipCode
     * @param number
     * @param $street
     * @param $city
     * @param $loader
     */
    loadAddress(zipCode, number, $street, $city, $loader) {
        if (!zipCode.length || !number.length) {
            return;
        }
        zipCode = zipCode.replace(/\s/g, '');
        $loader.show();
        $.getJSON(`/?action=ajax/getAddress&zipcode=${zipCode}&number=${number}`)
            .done(data => {
                if (data.street) {
                    $street.val(data.street);
                }
                if (data.city) {
                    $city.val(data.city);
                }
            }).always(() => {
            $loader.hide();
        });
    }

    /**
     *
     * @param event
     */
    getLocations(event) {
        event.preventDefault();
        event.stopPropagation();
        let zip = $('#servicePointForm').find('input[name=zipCode]').val();
        $.ajax({
            type: 'post',
            url: '/?action=cart/getLocations',
            data: {zip},
            dataType: 'json'
        }).done(data => {
            $('#pakjegemak-values').text(data);
            if (event.data.hasOwnProperty('thisClass') && event.data.thisClass.hasOwnProperty('formErrorConstants')) {
                event.data.thisClass.formErrorConstants.init();
            }
        });
    }

    initCoupon() {
        $('#couponForm').on('click', '.button',  event => {
            $('#discoutCoupon').submit();
        });
    }

    initPayment() {
        $('form#paymentMethod').on('click', 'button', $.proxy(this.handleSubmitForm, this));
        $('.js_payment-option').on('click', (event) => {
            $(document).find('.notice-error').remove();
        });
        $('.js_choose-payment-method').on('click', (event) => {
            $(document).find('.notice-error').remove();
        });
    }

    handleSubmitForm(event) {
        event.preventDefault();
        const $input = $('input:checked');
        const paymentMethod = $input.attr('id');
        const isNeedsToSendPaymentData = ['adyencreditcard', 'mistercash'].includes(paymentMethod);

        if (isNeedsToSendPaymentData) {
            this.setPaymentMethod(paymentMethod, $('#selectedCountry').val(), event);
            return;
        }

        this.checkPaymentForm(event);
    }

    setPaymentMethod(paymentmethod, selectedCountry, event) {
        let data = {
            paymentMethod: paymentmethod,
            country: selectedCountry
        };

        if (paymentmethod === 'adyencreditcard' || paymentmethod === 'mistercash') {
            data.adyenData = $('#adyenData').val();
        }

        $.ajax({
            type: 'post',
            dataType: 'json',
            url: '/?action=cart/setPaymentMethod',
            data: data
        }).always(
            () => this.checkPaymentForm(event)
        );
    }

    checkPaymentForm(event) {
        const $input = $('input:checked');

        if (!Boolean(document.getElementById('adyenData').value)
            && $input.attr('id') === 'adyencreditcard'
            && (
                event.target.classList.contains('js_stored-payment-method')
                || event.target.parentElement.classList.contains('js_stored-payment-method')
            )
        ) {
            return false;
        }

        event.preventDefault();
        let $form = $('form#paymentMethod');
        let child = this.checkChildPayment($form);

        if (!child) {
            return false;
        }

        $form.submit();
    }

    checkChildPayment($form) {
        const errorInput = $form.find('.payment-error');
        const isAdyenFieldsFilled = $('.js_choose-payment-method-adyen:not(.hidden)').length
            && document.getElementById('adyenData').value;
        const objPay = {
            ideal: 'payment_ideal_not_set_child',
            adyenideal: 'payment_ideal_not_set_child',
            ogonestd: 'payment_creditcard_not_set_child',
            adyencreditcard: 'payment_adyen_error',
        };
        // Check if there's a child payment and if one is selected.
        const payMethod = $form.find('input.paymentmethod').filter(':checked');
        const payType = payMethod.attr('id');
        const adyenPaymentCondition = (payType === 'adyencreditcard') && isAdyenFieldsFilled;
        const otherPaymentCondition = (payType !== 'adyencreditcard') &&
          ($form.find('#parentId-' + payMethod.attr('id') + ' option:selected').val() !== 'none_id');

        if (!this.formErrorConstants.validateInputElementCollection($form.find('.paymentmethod:enabled'))) {
          errorInput.attr('data-error', 'nopaymentmehod');
          this.formErrorConstants.init();
          return false;
        }

        if ( payType in objPay) {
            const errorMessage = objPay[payType];

            $form.find('.error-message').remove();

            if (adyenPaymentCondition || otherPaymentCondition) {
                return true;
            } else {
                errorInput.attr('data-error', errorMessage);
                this.formErrorConstants.removeErrors($form);
                this.formErrorConstants.init();
                return false;
            }
        }
        return true;
    }

    shippings() {
        let $shippingMethod = $('.check-shipping-method');
        $shippingMethod.on('change', 'input[name=shippingMethod]', this.changeShippingMethod.bind(this));
        $shippingMethod.on('change', '.selectDay, input[name=timeframe]', this.setShippingDate.bind(this));
        this.checkShippingForm();
    }

    changeShippingMethod(event) {
        let $target = $(event.currentTarget);
        let selectElement = $('#pakjegemak-values');

        if ($target.val() === 'pakjegemak') {
            if (selectElement.is(':hidden')) {
                selectElement.show();
            }
        } else {
            if (selectElement.is(':visible')) {
                selectElement.hide();
            }
        }
        this.setShippingMethod($target.val());
    }

    setShippingMethod(shippingMethod) {
        $.ajax({
            type: 'post',
            dataType: 'json',
            url: '/?action=cart/setShippingMethodChoice',
            data: {
                shippingMethod
            }
        });
    }

    setShippingDate(event) {
        let data = {};
        data[$(event.currentTarget).prop('name')] = $(event.currentTarget).val();

        $.ajax({
            type: 'post',
            dataType: 'json',
            url: '/?action=cart/setShippingDate',
            data: data
        });
    }

    createNewSameEmail() {
        let form = $('#loginNoAccountForm');
        let error = form.find('.notice-error');

        if (error.length && this.mobileDetect.mobile()) {
            $("html, body").animate({ scrollTop: error.offset().top - 200 }, 500);
        }
        form.on('click', '.add-new-account', function (event) {
            event.preventDefault();
            form.append('<input type="hidden" name="createnewcustomer" value="1" />');
            form.submit();
        })
    }

    checkShippingForm()
    {
        let form = $('#shippingMethod');

        form.on('click', '.check-form', {'form': form }, event => {
            event.preventDefault();
            let form = event.data.form;
            let formErrorElement = form.find('.show-form-error');
            let messageFormValidate = form.attr('data-check-form');
            let messageZipCodeValidate = form.attr('data-check-selection');
            let collectionFormElements =  form.find('.validate-value');
            if (this.formErrorConstants.validateInputElementCollection(collectionFormElements)) {
                formErrorElement.text('');
                let showError = formErrorElement.next();
                if (showError.hasClass('notice-error')) {
                    showError.remove();
                }
                let selectParentElement = collectionFormElements.filter(function() { return $(this).is(':checked');});

                let collectionElements =  selectParentElement.parent().find('input.validate-element');
                if (this.formErrorConstants.validateInputElementCollection(collectionElements)) {
                    form.submit();
                } else {
                    form.find('.show-error-element').html('<input type="hidden" data-error="' + messageZipCodeValidate + '">');
                    this.formErrorConstants.init();
                }
            } else {
                formErrorElement.html('<input type="hidden" data-error="' + messageFormValidate + '">');
                this.formErrorConstants.init();
            }
        });
    }

    createNewUser() {
        let tooltip = new Tooltip();
        tooltip.init();
        let form = $('#userInfoForm');
        form.on('click', '.check-form', {'form': form},  event => {
            let allowSendForm = true;
            event.preventDefault();
            let form = event.data.form;
            this.formErrorConstants.removeErrors(form);
            this.formErrorConstants.removeDataError(form);
            form.find('input:required, select:required').not(':button, :hidden').each(function (i, element) {
                let _element = $(element);
                let errorMessage = _element.data('error-message');
                if (errorMessage) {
                    let value = _element.val();
                    if (!value || value.length === 0) {
                        allowSendForm = false;
                        _element.attr('data-error', errorMessage);
                    }
                }
            });
            if (allowSendForm) {
                form.submit();
            } else {
                this.formErrorConstants.init();
            }
        });
    }
}

$(document).ready(function () {
    let checkout = new Checkout();
    checkout.init();
});
